import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext, SET_ZONE } from '../context/AppContext';
import CountryMap from './region-maps/CountryMap';
import AlabamaMap from './region-maps/states/AlabamaMap';
import ArizonaMap from './region-maps/states/ArizonaMap';
import ArkansasMap from './region-maps/states/ArkansasMap';
import CaliforniaMap from './region-maps/states/CaliforniaMap';
import ColoradoMap from './region-maps/states/ColoradoMap';
import FloridaMap from './region-maps/states/FloridaMap';
import GeorgiaMap from './region-maps/states/GeorgiaMap';
import IdahoMap from './region-maps/states/IdahoMap';
import IllinoisMap from './region-maps/states/IllinoisMap';
import IndianaMap from './region-maps/states/IndianaMap';
import IowaMap from './region-maps/states/IowaMap';
import KansasMap from './region-maps/states/KansasMap';
import KentuckyMap from './region-maps/states/KentuckyMap';
import LouisianaMap from './region-maps/states/LouisianaMap';
import MaineMap from './region-maps/states/MaineMap';
import MassachusettsMap from './region-maps/states/MassachusettsMap';
import MichiganMap from './region-maps/states/MichiganMap';
import MinnesotaMap from './region-maps/states/MinnesotaMap';
import MississippiMap from './region-maps/states/MississippiMap';
import MissouriMap from './region-maps/states/MissouriMap';
import MontanaMap from './region-maps/states/MontanaMap';
import NebraskaMap from './region-maps/states/NebraskaMap';
import NevadaMap from './region-maps/states/NevadaMap';
import NewHampshireMap from './region-maps/states/NewHampshireMap';
import NewMexicoMap from './region-maps/states/NewMexicoMap';
import NewYorkMap from './region-maps/states/NewYorkMap';
import NorthCarolinaMap from './region-maps/states/NorthCarolinaMap';
import NorthDakotaMap from './region-maps/states/NorthDakotaMap';
import OhioMap from './region-maps/states/OhioMap';
import OklahomaMap from './region-maps/states/OklahomaMap';
import OregonMap from './region-maps/states/OregonMap';
import PennsylvaniaMap from './region-maps/states/PennsylvaniaMap';
import SouthDakotaMap from './region-maps/states/SouthDakotaMap';
import SouthCarolinaMap from './region-maps/states/SouthCarolinaMap';
import TennesseeMap from './region-maps/states/TennesseeMap';
import TexasMap from './region-maps/states/TexasMap';
import UtahMap from './region-maps/states/UtahMap';
import VermontMap from './region-maps/states/VermontMap';
import VirginiaMap from './region-maps/states/VirginiaMap';
import WashingtonMap from './region-maps/states/WashingtonMap';
import WestVirginiaMap from './region-maps/states/WestVirginiaMap';
import WisconsinMap from './region-maps/states/WisconsinMap';
import WyomingMap from './region-maps/states/WyomingMap';
import '../css/header.css';
import '../css/body.css';

const StateMap = ({ stateId, onZoneClick }) => {
	const stateMapComponents = {
		AL: AlabamaMap,
		AR: ArkansasMap,
		AZ: ArizonaMap,
		CA: CaliforniaMap,
		CO: ColoradoMap,
		FL: FloridaMap,
		GA: GeorgiaMap,
		ID: IdahoMap,
		IL: IllinoisMap,
		IN: IndianaMap,
		IA: IowaMap,
		KS: KansasMap,
		KY: KentuckyMap,
		LA: LouisianaMap,
		MA: MassachusettsMap,
		ME: MaineMap,
		MI: MichiganMap,
		MN: MinnesotaMap,
		MS: MississippiMap,
		MO: MissouriMap,
		MT: MontanaMap,
		NE: NebraskaMap,
		NV: NevadaMap,
		NH: NewHampshireMap,
		NM: NewMexicoMap,
		NY: NewYorkMap,
		NC: NorthCarolinaMap,
		ND: NorthDakotaMap,
		OH: OhioMap,
		OK: OklahomaMap,
		OR: OregonMap,
		PA: PennsylvaniaMap,
		SC: SouthCarolinaMap,
		SD: SouthDakotaMap,
		TN: TennesseeMap,
		TX: TexasMap,
		UT: UtahMap,
		VT: VermontMap,
		VA: VirginiaMap,
		WA: WashingtonMap,
		WV: WestVirginiaMap,
		WI: WisconsinMap,
		WY: WyomingMap,
	};

	const SelectedState = stateMapComponents[stateId];

	const handleZoneClick = (zoneId) => {
		onZoneClick(zoneId);
	};

	return (
		<div>
			{SelectedState ? (
				<SelectedState className='state-map' onZoneClick={handleZoneClick} />
			) : (
				<p>No map available for this state.</p>
			)}
		</div>
	);
};

export default StateMap;
